const NORWEGIAN_LANGUAGE_CODES = new Set(['nb', 'nn'])

export default function resolveStoreBadgeLanguage(language: string): string {
  const normalizedLanguage = language.toLowerCase().split('-')[0]
  if (NORWEGIAN_LANGUAGE_CODES.has(normalizedLanguage)) {
    return 'no'
  }

  return normalizedLanguage
}
